























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RkProgress extends Vue {
  @Prop({
    default: 0,
  }) public precent!: number;
  @Prop({
    default: '#3fb1e3',
  }) public color!: string;
}
